import { connect } from 'react-redux';
import i18next from 'i18next';
import React, { useState } from 'react';

import { Button } from '@commons/utils/styledLibraryComponents';
import WhiteCard from '@commons/WhiteCard';

import { PublicApiKeysContainer } from './styledComponents';

import { PublicApiDrawer } from './PublicApiComponents/PublicApiDrawer';
import { publicKeysService } from '@services/backoffice/publicKeys';
import PublicApiKeysTable from './PublicApiComponents/PublicApiKeysTable';

import { showErrorMessage } from '@actions/messageconfirmation';

const GeneratePublicApiCard = ({ showErrorMessage }) => {
  const [displayGenerateApiKeyDrawer, setDisplayGenerateApiKeyDrawer] = useState(false);
  const [selectedKey, setSelectedKey] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleEditKey = async (key) => {
    try {
      const { resources, restrictedStoreIds } = await publicKeysService.getApiKeysResourcesById(
        key.id,
      );
      setSelectedKey({ ...key, resources, restrictedStoreIds });
      setDisplayGenerateApiKeyDrawer(true);
    } catch (error) {
      showErrorMessage(i18next.t('ADMIN.INTEGRATIONS.PUBLIC_API_KEYS.UPDATE_ERROR'));
    }
  };

  const handleClose = () => {
    setDisplayGenerateApiKeyDrawer(false);
    setSelectedKey(null);
  };

  const handleSuccess = () => {
    handleClose();
    setRefreshKey((prev) => prev + 1);
  };

  return (
    <WhiteCard
      renderContent={
        <PublicApiKeysContainer>
          <Button
            buttonCustomStyle={{ padding: '0px' }}
            color={'inpulse-outline'}
            handleClick={() => setDisplayGenerateApiKeyDrawer(true)}
            icon={'/images/inpulse/plus-black-small.svg'}
            iconCustomStyle={{ width: '16px', height: '16px' }}
            label={i18next.t('ADMIN.INTEGRATIONS.PUBLIC_API_KEYS.GENERATE_NEW_API_KEY')}
            noBorder
          />

          <PublicApiKeysTable refreshKey={refreshKey} onEdit={handleEditKey} />
          <PublicApiDrawer
            displayGenerateApiKeyDrawer={displayGenerateApiKeyDrawer}
            selectedKey={selectedKey}
            onClose={handleClose}
            onSuccess={handleSuccess}
          />
        </PublicApiKeysContainer>
      }
      title={i18next.t('ADMIN.INTEGRATIONS.PUBLIC_API_KEYS.APIKEYS')}
    />
  );
};

const mapDispatchToProps = (dispatch) => ({
  showErrorMessage: (msg) => dispatch(showErrorMessage(msg)),
});

export default connect(null, mapDispatchToProps)(GeneratePublicApiCard);
